<script>
import DataProvider from './DataProvider.vue';
import FieldRepository from '../../js/repository/FieldRepository';

export default {
    components: {
        'kgr-data-provider': DataProvider,
    },
    props: {
        areaId: {
            type: String,
            required: true,
        },
        locationId: {
            type: String,
            required: true,
        },
        fieldId: {
            type: String,
            required: true,
        },
        callback: {
            type: Function,
            required: false,
        },
    },
    render(createElement) {
        return createElement(DataProvider, {
            props: {
                repository: FieldRepository.find,
                params: [this.locationId, this.areaId, this.fieldId],
                callback: this.callback,
            },
            scopedSlots: this.$scopedSlots,
        });
    },
};
</script>
